<template>
  <div>
    <v-form v-model="mainFormValid" class="pa-4">
      <v-text-field
        v-model="internalValue.name"
        :rules="$options.rules.name"
        label="Nom"
        type="text"
        @input="change"
      />
      <ag-switch
        v-model="internalValue.clone"
        inset
        label="Dupliquer une référence"
        @input="change"
      />

      <ag-autocomplete
        v-if="!internalValue.clone"
        v-model="internalValue.partType"
        :rules="$options.rules.partType"
        label="Type de référence"
        :item-list="partTypeList"
        item-text="name"
        @input="change"
      />
      <ag-autocomplete
        v-if="internalValue.clone"
        v-model="internalValue.partNumberToDuplicate"
        :rules="$options.rules.partNumberToDuplicate"
        label="Référence à dupliquer"
        :item-list="partNumberList"
        item-text="name"
        @input="change"
      />
    </v-form>
  </div>
</template>

<script>
import Repositories from 'src/repositories'
import Helpers from 'src/utils/helpers'
import FormRules from 'src/utils/form-rules'
import AgSwitch from 'src/components/common/AgSwitch'
import AgAutocomplete from 'src/components/common/AgAutocomplete'

export default {
  name: 'PartNumberForm',
  components: { AgSwitch, AgAutocomplete },
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    internalValue: null,
    mainFormValid: false,
    partTypeList: [],
    partNumberList: [],
  }),
  computed: {
    isValidPartNumber () {
      return this.mainFormValid
    },
  },
  watch: {
    value: {
      immediate: true,
      handler (value) {
        this.internalValue = Helpers.clone(value)
        this.$emit('validate', this.isValidPartNumber)
      },
    },
    isValidPartNumber: {
      immediate: true,
      handler () {
        this.$emit('validate', this.isValidPartNumber)
      },
    },
  },
  async mounted () {
    this.partTypeList = await Repositories.partType.getList()
    this.partNumberList = await Repositories.partNumber.getList({ archived: false })
  },
  methods: {
    change () {
      this.$emit('input', this.internalValue)
      this.$emit('validate', this.isValidPartNumber)
    },
  },
  rules: {
    name: [
      FormRules.required('requis'),
    ],
    partType: [
      FormRules.required('requis'),
    ],
    partNumberToDuplicate: [
      FormRules.required('requis'),
    ],
  },
}
</script>
